import { useContract } from '@thirdweb-dev/react-core';

import { algebraPoolABI } from '../../../abis/v3';
import { useAsync } from 'react-use';

export function useAlgebraPoolLiquidity({
  address
}: {
  address: string | undefined;
}) {
  const { contract } = useContract(address, algebraPoolABI);

  const { value, loading, error } = useAsync(async () => {
    if (!contract) {
      return;
    }

    return contract.call('liquidity');
  }, [contract]);

  return {
    data: value,
    isLoading: loading,
    isError: error
  };
}
